import { render, staticRenderFns } from "./ProjectsUserComponent.vue?vue&type=template&id=0b6cdc3e"
import script from "./ProjectsUserComponent.js?vue&type=script&lang=js&external"
export * from "./ProjectsUserComponent.js?vue&type=script&lang=js&external"
import style0 from "./ProjectsUserComponent.vue?vue&type=style&index=0&id=0b6cdc3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports